/*
 * @Author: Merlin
 * @Date: 2023-12-11 14:43:44
 * @LastEditors: Merlin
 * @LastEditTime: 2024-03-11 11:08:23
 * @Description: 
 */

import {default as cnLang01} from './cn.js';
import {default as enLang01} from './en.js';
import {oGameCommon} from './game.common.js';
import {oCrashGame} from './crash.js';
import {oHiloGame} from './hilo.js';
import {oKenoGame} from './keno.js';
import {oMinesGame} from './mines.js';
import {oPharaohGame} from './pharaoh.js';
import {oWavesGame} from './waves.js';
import {oRouletteGame} from './roulette.js';
import {oGoldenFlowerLang} from './goldenFlowerLang.js';
import {oRedPacketMines} from './redPacketMines.js';
import {notificationPage} from './notificationPage.js';
import {oNiuniuGame} from './niuniu.js'
import {oJisuzhajinhuaLang} from './jisuzhajinhuaLang.js';
import {
    oResultTab,
    oRTP,
    oMinMaxTip,
    oFavoriteBtn,
    oLang,
    oMusic,
    oJackpot,
    oLeavingTips,
    oHeaderMenu, 
    oAvatarManagemtn,
} from './widgets.js';


function getLang(oLangInfo, sPrefix = ''){
    sPrefix &&= sPrefix + '.';
    const [en, cn] = [{}, {}];
    Object.entries(oLangInfo).forEach(oThisOne => {
        const [sKey, oVal] = oThisOne;
        const sNewKey = `${sPrefix}${sKey}`;
        en[sNewKey] = oVal.en;
        cn[sNewKey] = oVal.cn;
    });
    return {en, cn};
}


const {enLang, cnLang} = [
    getLang(oCrashGame, 'crash'),
    getLang(oResultTab, 'result_tab'),
    getLang(oRTP, 'RTP_tip'),
    getLang(oMinMaxTip, 'minMax'),
    getLang(oFavoriteBtn, 'favorite'),
    getLang(oLang, 'lang'),
    getLang(oMusic, 'music'),
    getLang(oHiloGame, 'hilo'),
    getLang(oGameCommon, 'game'),
    getLang(oJackpot, 'jackpot'),
    getLang(oKenoGame, 'keno'),
    getLang(oRouletteGame, 'roulette'),
    getLang(oMinesGame, 'mines'),
    getLang(oLeavingTips, 'exitGame'),
    getLang(oPharaohGame, 'pharaoh'),
    getLang(oWavesGame, 'waves'),
    getLang(oHeaderMenu, 'headerMenu'),
    getLang(notificationPage, 'notificationPage'),
    getLang(oAvatarManagemtn, 'avatar'),
    getLang(oRedPacketMines, 'redPacketMines'),
    getLang(oGoldenFlowerLang, 'goldenFlower'),
    getLang(oNiuniuGame,'niuniu'),
    getLang(oJisuzhajinhuaLang, 'jisuzhajinhua')
].reduce((oResult, oCur) => {
    Object.assign(oResult.enLang, oCur.en);
    Object.assign(oResult.cnLang, oCur.cn);
    return oResult;
}, {
    enLang: {},
    cnLang: {},
});


export const cn = { ...cnLang01, ...cnLang, };
export const en = { ...enLang01, ...enLang, };
